import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "./components/ui/sonner";
import { Navbar } from "./components/Navbar";
import { Footer } from "./components/Footer";
import { LanguageProvider } from "./context/LanguageContext";

// Pages
import Home from "./pages/Home";
import Services from "./pages/Services";
import Portfolio from "./pages/Portfolio";
import Contact from "./pages/Contact";
import EquipmentRental from "./pages/EquipmentRental";
import EquipmentDetail from "./pages/EquipmentDetail";
import WorkSite from "./pages/WorkSite";
import Transport from "./pages/Transport";
import Concrete from "./pages/Concrete";
import HeavyEquipment from "./pages/Excavation";
import Welding from "./pages/Welding";
import AdminLogin from "./pages/AdminLogin";
import AdminDashboard from "./pages/AdminDashboard";

// Scroll to top on route change
function ScrollToTop() {
  const { pathname } = useLocation();
  
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  
  return null;
}

// Main app content with routes
function AppContent() {
  return (
    <LanguageProvider>
      <div className="App min-h-screen flex flex-col">
        <ScrollToTop />
        <Navbar />
        <main className="flex-1">
          <Routes>
            {/* English Routes (default) */}
            <Route path="/" element={<Home />} />
            <Route path="/services" element={<Services />} />
            <Route path="/portfolio" element={<Portfolio />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/equipment-rental" element={<EquipmentRental />} />
            <Route path="/equipment/:id" element={<EquipmentDetail />} />
            <Route path="/work-site" element={<WorkSite />} />
            <Route path="/transport" element={<Transport />} />
            <Route path="/concrete" element={<Concrete />} />
            <Route path="/excavation" element={<HeavyEquipment />} />
            <Route path="/welding" element={<Welding />} />
            
            {/* French Routes */}
            <Route path="/fr" element={<Home />} />
            <Route path="/fr/services" element={<Services />} />
            <Route path="/fr/portfolio" element={<Portfolio />} />
            <Route path="/fr/contact" element={<Contact />} />
            <Route path="/fr/equipment-rental" element={<EquipmentRental />} />
            <Route path="/fr/equipment/:id" element={<EquipmentDetail />} />
            <Route path="/fr/work-site" element={<WorkSite />} />
            <Route path="/fr/transport" element={<Transport />} />
            <Route path="/fr/concrete" element={<Concrete />} />
            <Route path="/fr/excavation" element={<HeavyEquipment />} />
            <Route path="/fr/welding" element={<Welding />} />
            
            {/* Admin Routes (no language prefix) */}
            <Route path="/admin" element={<AdminLogin />} />
            <Route path="/admin/dashboard" element={<AdminDashboard />} />
          </Routes>
        </main>
        <Footer />
        <Toaster position="top-right" richColors />
      </div>
    </LanguageProvider>
  );
}

function App() {
  return (
    <HelmetProvider>
      <BrowserRouter>
        <AppContent />
      </BrowserRouter>
    </HelmetProvider>
  );
}

export default App;
